import React from "react";

function Pricing() {
  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "auto",
        padding: "60px 20px",
        backgroundColor: "#121212", // dark background but readable
        color: "#f0f0f0", // light text
        borderRadius: "12px",
        boxShadow: "0 8px 20px rgba(0,0,0,0.5)",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <h1
        style={{
          fontSize: "2.5rem",
          marginBottom: "20px",
          color: "#00bfff", // accent color for headings
        }}
      >
        SourceCodey Digital Products
      </h1>

      <p style={{ fontSize: "1.1rem", lineHeight: "1.6", marginBottom: "40px" }}>
        SourceCodey is a marketplace where developers can buy and sell
        high-quality source code, templates, and software projects.
      </p>

      <h2
        style={{
          fontSize: "2rem",
          marginBottom: "20px",
          borderBottom: "2px solid #00bfff",
          display: "inline-block",
          paddingBottom: "5px",
        }}
      >
        Typical Product Pricing
      </h2>

      <ul style={{ listStyle: "none", padding: 0, marginBottom: "40px" }}>
        {[
          { name: "Mobile App Source Code", price: "$10 to $300" },
          { name: "Website Templates", price: "$8 to $100" },
          { name: "Full Software Projects", price: "$20 to $350" },
          { name: "UI/UX Design Kits", price: "$5 to $25" },
        ].map((item, index) => (
          <li
            key={index}
            style={{
              backgroundColor: "#1e1e1e",
              marginBottom: "15px",
              padding: "20px",
              borderRadius: "8px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontSize: "1.1rem",
            }}
          >
            <span>{item.name}</span>
            <span style={{ color: "#00bfff", fontWeight: "600" }}>
              {item.price}
            </span>
          </li>
        ))}
      </ul>

      <p style={{ fontSize: "1rem", marginBottom: "15px" }}>
        All purchases include instant digital download after payment.
      </p>

      <p style={{ fontSize: "1rem" }}>
        Visit our marketplace to explore available products.
      </p>
    </div>
  );
}

export default Pricing;